// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#V-17659F03-834F-4C43-B081-DF8E7415727E .warning-icon {\n  color: yellow;\n}\n", "",{"version":3,"sources":["webpack://src/Warehouse/WarehouseKeeping/warehouseKeepingDetail/warehouseKeepingDetail.less"],"names":[],"mappings":"AACI;EACI,aAAA;AAAR","sourcesContent":["#V-17659F03-834F-4C43-B081-DF8E7415727E{\n    & .warning-icon{\n        color: yellow;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
